import React from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import Constant from '../../../Constant'
import moment from 'moment'
import axios from 'axios'
// import Toggle from 'react-toggle'

class PackageAdd extends React.Component {
  state = {
    name_en: '',
    name_ar: '',
    desc_en: '',
    desc_ar: '',

    start_day: '',
    end_day: '',

    // used as package period
    start_date: '',
    end_date: '',

    // used as package dates in case of special package
    from_date: '',
    to_date: '',

    price: '',
    price_before_markup: '',

    total_days: '',
    show_total_days: false,

    order: '',
    isSaving: false,
    isData: false,
    Edit: false,

    ref_package_id: '',
    globalPackages: [],
    packageDates: [],
    readOnly: false,
  }

  componentDidMount() {
    if (this.props.id) {
      this.getPackageDetails()
    }

    this.getGlobalPackageList()
  }

  getGlobalPackageList = async () => {
    await axios
      .get(Constant.getAPI() + `/chalet/get-chalet-global-packages`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            globalPackages: res.data.data?.filter((item) => item.is_active),
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          this.showErrorAlert(err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message)
        }
      })
  }

  getPackageDetails = async () => {
    await axios
      .get(Constant.getAPI() + `/chalet/get-package-details/${this.props.id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          const data = res?.data?.data
          this.setState({
            ...data,
            packageDates: data?.package_dates?.map((ele) => {
              return { from_date: ele.from_date, to_date: ele.to_date, price: ele.price }
            }),
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          this.showErrorAlert(err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message)
        }
      })
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value })

    if (event.target.name == 'ref_package_id') {
      let selectedData = this.state.globalPackages.find((item) => item.id == event.target.value)

      let data = {
        name_en: selectedData.name_en,
        name_ar: selectedData.name_ar,
        desc_en: selectedData.desc_en,
        desc_ar: selectedData.desc_ar,

        start_date: selectedData.package_start_date || '',
        end_date: selectedData.package_end_date || '',
      }

      data.from_date = selectedData.start_date
      data.to_date = selectedData.end_date

      data.start_day = selectedData.start_day
      data.end_day = selectedData.end_day
      if (selectedData.is_special_package) {
        data.start_date = selectedData.start_date
        data.end_date = selectedData.end_date

        data.show_total_days = true
        data.total_days = moment(selectedData.end_date).diff(moment(selectedData.start_date), 'days') + 1
      } else {
        data.show_total_days = false
        data.total_days = null
      }

      this.setState(data)
    }
  }

  onSaveData = () => {
    let data = {
      chalet_id: this.props.source_id,
      ref_package_id: this.state.ref_package_id,

      name_en: this.state.name_en,
      name_ar: this.state.name_ar,
      desc_en: this.state.desc_en,
      desc_ar: this.state.desc_ar,

      start_day: this.state.start_day,
      end_day: this.state.end_day,

      start_date: this.state.start_date,
      end_date: this.state.end_date,

      from_date: this.state.from_date,
      to_date: this.state.to_date,

      price: this.state.price,
      price_before_markup: this.state.price_before_markup,
      show_total_days: this.state.show_total_days,

      is_active: this.state.is_active,
      order: this.state.order,
    }

    if (this.state.total_days) {
      data.total_days = this.state.total_days
    }

    if (!data.ref_package_id) {
      this.showErrorAlert('Please select Global Package')
      return
    } else if (!data.start_date || !data.end_date || moment(data.start_date) >= moment(data.end_date)) {
      this.showErrorAlert('Invalid Package Period Dates')
      return
    }

    data.package_dates = JSON.stringify(this.state.packageDates)

    this.setState({ isData: true })

    if (this.props.id) {
      data.id = this.props.id
      axios
        .put(Constant.getAPI() + '/chalet/update-package', data, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          this.setState({ isData: false })
          if (res.status === 200) {
            Swal.fire('Updated !', `Package has been Updated`, 'success')
            window.history.back()
          }
        })
        .catch((err) => {
          this.setState({ isData: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            this.showErrorAlert(err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message)
          }
        })
    } else {
      axios
        .post(Constant.getAPI() + '/chalet/add-package', data, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          this.setState({ isData: false })
          if (res.status === 200) {
            Swal.fire('Added !', `Package has been Added`, 'success')
            window.history.back()
          }
        })
        .catch((err) => {
          this.setState({ isData: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            this.showErrorAlert(err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message)
          }
        })
    }
  }

  showErrorAlert = (title) => {
    Swal.fire({
      title: title,
      icon: 'error',
      type: 'error',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Ok',
    })
  }

  addDates = () => {
    const newEntry = {
      from_date: '',
      to_date: '',
      price: 0,
    }
    const dataCopy = [...this.state.packageDates, newEntry]

    this.setState({
      ...this.state,
      packageDates: dataCopy,
    })
  }

  removeDate = (index) => {
    const dataCopy = [...this.state.packageDates]

    dataCopy.splice(index, 1)

    this.setState({
      ...this.state,
      packageDates: dataCopy,
    })
  }

  handleDateChange = (event, index) => {
    const { name, value } = event.target
    const dataCopy = [...this.state.packageDates]
    dataCopy[index][name] = value
    this.setState({
      ...this.state,
      packageDates: dataCopy,
    })
  }

  render() {
    return (
      <div className="">
        <div className="card-body">
          <div className="row m-b-20">
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Link Global Package</label>
                <div className="col-sm-9">
                  <select
                    name="ref_package_id"
                    className="form-control"
                    value={this.state.ref_package_id}
                    onChange={this.handleChange}
                  >
                    <option value="">Select Option</option>
                    {this.state.globalPackages?.map((item) => {
                      return (
                        <option
                          value={item.id}
                          key={item.id}
                        >
                          {item?.ref_name || '--'}
                        </option>
                      )
                    })}
                  </select>
                </div>
              </div>
            </div>
            <div
              className="col-md-12"
              style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
            ></div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Package Name: English</label>
                <div className="col-sm-9">
                  <input
                    disabled
                    type="text"
                    className="form-control"
                    name="name_en"
                    id="name_en"
                    placeholder={`Package Name: English`}
                    onChange={this.handleChange}
                    value={this.state.name_en}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Package Name: Arabic</label>
                <div className="col-sm-9">
                  <input
                    disabled
                    type="text"
                    className="form-control"
                    name="name_ar"
                    id="name_ar"
                    placeholder={`Package Name: Arabic`}
                    onChange={this.handleChange}
                    value={this.state.name_ar}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Description: English</label>
                <div className="col-sm-9">
                  <textarea
                    disabled
                    type="text"
                    className="form-control"
                    name="desc_en"
                    placeholder="Description: English"
                    onChange={this.handleChange}
                    value={this.state.desc_en}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Description: Arabic</label>
                <div className="col-sm-9">
                  <textarea
                    disabled
                    type="text"
                    className="form-control"
                    name="desc_ar"
                    placeholder="Description: Arabic"
                    onChange={this.handleChange}
                    value={this.state.desc_ar}
                  />
                </div>
              </div>
            </div>
            <div
              className="col-md-12"
              style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
            ></div>
            <div className="col-md-12">
              <h6>Package Period</h6>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Start Date</label>
                <div className="col-sm-9">
                  <input
                    disabled
                    type="date"
                    className="form-control"
                    name="start_date"
                    id="start_date"
                    onChange={this.handleChange}
                    value={this.state.start_date}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">End Date</label>
                <div className="col-sm-9">
                  <input
                    disabled
                    type="date"
                    className="form-control"
                    name="end_date"
                    id="end_date"
                    onChange={this.handleChange}
                    value={this.state.end_date}
                  />
                </div>
              </div>
            </div>
            <div
              className="col-md-12"
              style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
            ></div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">From Date</label>
                <div className="col-sm-9">
                  <input
                    disabled
                    type="date"
                    className="form-control"
                    name="from_date"
                    id="from_date"
                    onChange={this.handleChange}
                    value={this.state.from_date}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">To Date</label>
                <div className="col-sm-9">
                  <input
                    disabled
                    type="date"
                    className="form-control"
                    name="to_date"
                    id="to_date"
                    onChange={this.handleChange}
                    value={this.state.to_date}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Start Day</label>
                <div className="col-sm-9">
                  <select
                    disabled
                    name="start_day"
                    className="form-control"
                    value={this.state.start_day}
                    onChange={this.handleChange}
                  >
                    <option value="">Select Option</option>
                    <option value="sunday">Sunday</option>
                    <option value="monday">Monday</option>
                    <option value="tuesday">Tuesday</option>
                    <option value="wednesday">Wednesday</option>
                    <option value="thursday">Thursday</option>
                    <option value="friday">Friday</option>
                    <option value="saturday">Saturday</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">End Day</label>
                <div className="col-sm-9">
                  <select
                    disabled
                    name="end_day"
                    className="form-control"
                    value={this.state.end_day}
                    onChange={this.handleChange}
                  >
                    <option value="">Select Option</option>
                    <option value="sunday">Sunday</option>
                    <option value="monday">Monday</option>
                    <option value="tuesday">Tuesday</option>
                    <option value="wednesday">Wednesday</option>
                    <option value="thursday">Thursday</option>
                    <option value="friday">Friday</option>
                    <option value="saturday">Saturday</option>
                  </select>
                </div>
              </div>
            </div>
            {this.state.total_days && (
              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Number of Days</label>
                  <div className="col-sm-9">
                    <input
                      disabled
                      type="text"
                      className="form-control"
                      name="total_days"
                      id="total_days"
                      value={this.state.total_days}
                    />
                  </div>
                </div>
              </div>
            )}

            <div
              className="col-md-12"
              style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
            ></div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Price</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="price"
                    id="price"
                    placeholder={`Price`}
                    onChange={this.handleChange}
                    value={this.state.price}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Price Before Markup</label>
                <div className="col-sm-9">
                  <input
                    type="number"
                    className="form-control"
                    name="price_before_markup"
                    id="price_before_markup"
                    placeholder="Price Before Markup"
                    onChange={this.handleChange}
                    value={this.state.price_before_markup}
                    min={0}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Is Active</label>
                <div className="col-sm-9">
                  <select
                    name="is_active"
                    className="form-control"
                    value={this.state.is_active}
                    onChange={this.handleChange}
                  >
                    <option value="true">True</option>
                    <option value="false">False</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Order</label>
                <div className="col-sm-9">
                  <input
                    type="number"
                    min={0}
                    className="form-control"
                    name="order"
                    id="order"
                    placeholder={`Order`}
                    onChange={this.handleChange}
                    value={this.state.order}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="card border">
            <div
              className="card-header"
              style={{ paddingTop: 15, paddingBottom: 15 }}
            >
              <h3 className="float-left card-title">Add Dates</h3>
              <span className="float-right m-0">
                <button
                  disabled={this.state.readOnly}
                  className="btn btn-primary btn-sm"
                  onClick={this.addDates}
                >
                  Add More
                </button>
              </span>
            </div>
            {this.state.packageDates && this.state.packageDates.length ? (
              <div className="card-body">
                {this.state.packageDates.map((item, i) => {
                  return (
                    <div
                      className="card border m-0"
                      key={i}
                      style={{ background: '#ffe' }}
                    >
                      <div
                        className="card-header"
                        style={{ padding: 20, borderBottom: '1px solid #ddd' }}
                      >
                        <h5 className="float-left card-title">Option {i + 1}#</h5>
                        <span className="float-right">
                          <button
                            disabled={this.state.readOnly}
                            className="btn btn-danger btn-sm"
                            onClick={() => this.removeDate(i)}
                          >
                            Remove
                          </button>
                        </span>
                      </div>
                      <div className="card-body row">
                        <div className="col-12 col-md-6">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">From Date</label>
                            <div className="col-sm-9">
                              <input
                                type="date"
                                className="form-control"
                                name="from_date"
                                onChange={(event) => this.handleDateChange(event, i)}
                                value={item.from_date}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-12 col-md-6">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">To Date</label>
                            <div className="col-sm-9">
                              <input
                                type="date"
                                className="form-control"
                                name="to_date"
                                onChange={(event) => this.handleDateChange(event, i)}
                                value={item.to_date}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-12 col-md-6">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Price</label>
                            <div className="col-sm-9">
                              <input
                                type="number"
                                className="form-control"
                                name="price"
                                id="price"
                                placeholder="Price"
                                onChange={(event) => this.handleDateChange(event, i)}
                                value={item.price}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                })}
              </div>
            ) : null}
          </div>
          <div className="row float-right p-3">
            {this.state.isData ? (
              <button className="btn btn-grd-disabled mr-2">Saving...!</button>
            ) : (
              <button
                onClick={this.onSaveData}
                className="btn btn-grd-disabled mr-2"
              >
                <i className="icofont icofont-save"></i> Save
              </button>
            )}
            <Link
              to={`/chalet-package/${this.props.source_id}`}
              className="btn btn-outline-dark"
            >
              Cancel
            </Link>
          </div>
        </div>
      </div>
    )
  }
}

export default PackageAdd
